import React, { Component } from "react";
import * as styles from "./PunchCard.styles";
import { Form, H1, H2, FlexRow, Button } from "appStyles";
import { withRedux } from "helpers";
import { punchcardRedemptionTypeOptions } from "constants";
import EditBackground from "../EditBackground";
import { RadioOptions, SaveProgress } from "components";
import { css } from "react-emotion";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  padding: 20px;
  position: relative;
  padding: 1em;
  border-radius: 5px;
  margin-bottom: 3em;
  margin-top: 1em;
`;
class PunchCardSettings extends Component {
  state = {
    croppingAspectRatio: "1.0",
    showModal: false,
  };
  constructor(props) {
    super(props);
  }
  // const {
  //   actions: { updateApplication },
  //   activeApp: { punchcardRedemptionType, punchcardCode },
  // } = props;
  update = (field) => (value) => {
    this.props.actions.updateApplication(field, value);
  };

  addTempPunchCard = () => {
    this.props.actions.addTempPunchCard();
    this.props.actions.updateActiveEditor("newCard");
    this.setState({ showModal: true });
  };
  hasPunchCard = () => Object.keys(this.props.cards).length > 0;
  updateComponent = (component) => {
    const { activeTemplate } = this.props;
    const updatedTemplate = {
      ...this.props.activeTemplate,
    };
    updatedTemplate.components = activeTemplate.components.map((c) =>
      c.componentNumber === component.componentNumber ? component : c
    );
    this.props.actions.updateTemplate(updatedTemplate);
  };
  updateBackgroundColor = (backgroundColor) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      backgroundColor,
    };

    this.props.actions.updateTemplate(updatedTemplate);
  };

  updateBackgroundImage = (url) => {
    // "updating background image");
    let updatedTemplate = this.props.activeTemplate;
    if (url) {
      if (updatedTemplate.backgroundImage === null) {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: imageView(url),
        };
      } else {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: {
            ...this.props.activeTemplate.backgroundImage,
            url,
          },
        };
      }
    } else {
      updatedTemplate = {
        ...this.props.activeTemplate,
        backgroundImage: null,
      };
    }

    this.props.actions.updateTemplate(updatedTemplate);
  };
  updatePageName = (pageName) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      pageName,
    };
    this.props.actions.updateTemplate(updatedTemplate);
  };

  renderPageSettings = () => {
    // if (!this.hasDeal()) return null;
    const { activeApp, activeTemplate, activeEditor } = this.props;
    const { croppingAspectRatio } = this.state;
    return (
      <div className={container}>
        <EditBackground
          croppingAspectRatio={croppingAspectRatio}
          update={this.updatePic}
          updateComponent={this.updateComponent}
          pictureCatalogComponent={
            activeTemplate.type === "pictureCatalog"
              ? activeTemplate.components[0]
              : false
          }
          updateBackgroundColor={this.updateBackgroundColor}
          updateBackgroundImage={this.updateBackgroundImage}
          backgroundColor={activeTemplate.backgroundColor}
          backgroundImage={activeTemplate.backgroundImage}
          additionalPageSettings={this.additionalPageSettings}
          appId={activeApp.id}
        />
        <SaveProgress />
      </div>
    );
  };

  renderPunchCardRedemptionType = () => {
    const { punchcardRedemptionType } = this.props.activeApp;
    const { punchcardCode } = this.props;
    const isManual = punchcardRedemptionType == 1;
    const isCustomerScans = punchcardRedemptionType == 2;
    return (
      <React.Fragment>
        <div>
          <div
            style={{
              display: "flex",
              width: "416px",
              alignItems: "center",
              margin: "15px 0px",
            }}
            id="punchCardRide"
          >
            <H2
              fontSize="20px"
              className="heading"
              lineHeight="35px"
              style={{ margin: "0px" }}
            >
              Punchcard Redemption Type
            </H2>
          </div>
        </div>
        <p
          style={{
            fontSize: "12px",
            lineHeight: "14px",
            color: "#8C8C8C",
            margin: "15px 5px",
          }}
        >
          Select how customers can redeem punchcards in their app
        </p>
        <FlexRow width="100%" height="auto">
          <RadioOptions
            {...this.props}
            // value={redemptionType}
            value={punchcardRedemptionType}
            options={punchcardRedemptionTypeOptions}
            setValue={this.update("punchcardRedemptionType")}
            showPasswordInput={isManual}
            showQRCode={isCustomerScans}
            pageType="punchcard"
            // punchcardCode={punchcardCode}
            name={name}
          />
        </FlexRow>
      </React.Fragment>
    );
  };

  render() {
    const {
      cards,
      activeEditor,
      activeApp: { id },
    } = this.props;
    return (
      <div>
        {this.renderPageSettings()}
        <Form marginBottom="3em">
          <H1
            fontSize="24px"
            className="heading"
            lineHeight="35px"
            style={{ letterSpacing: "2px", textAlign: "left" }}
          >
            Punchcard Settings
          </H1>
          {this.renderPunchCardRedemptionType()}
          <br />

          <div style={{ textAlign: "center" }}>
            <Button
              onClick={this.addTempPunchCard}
              className="newRewardButton"
              style={{
                marginLeft: " 0px",
                marginBottom: "40px",
                display: "inline-flex",
                alignItems: "center",
                textAlign: "center",
                fontSize: "15px",
                lineHeight: "29px",
                borderRadius: "5.5px",
                backgroundColor: "#89d2d3",
                fontWeight: "bold",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                fontStyle: "normal",
                fontStretch: "normal",
                textTransform: "none",
              }}
            >
              <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon>
              Create New Punchcard
            </Button>
          </div>
          <SaveProgress />
        </Form>
      </div>
    );
  }
}

export default withRedux(PunchCardSettings);
